var map = {
	"../authorization/authorization.module": [
		"./src/app/authorization/authorization.module.ts",
		"authorization-authorization-module"
	],
	"../consolidated-students-scores/consolidated-students-scores.module": [
		"./src/app/consolidated-students-scores/consolidated-students-scores.module.ts"
	],
	"../home-page/home-page.module": [
		"./src/app/home-page/home-page.module.ts",
		"home-page-home-page-module"
	],
	"../logout/logout.module": [
		"./src/app/logout/logout.module.ts",
		"logout-logout-module"
	],
	"../student-activity/advanced-reporting-filters/advanced-reporting-filters.module": [
		"./src/app/student-activity/advanced-reporting-filters/advanced-reporting-filters.module.ts"
	],
	"../student-activity/session-options.module": [
		"./src/app/student-activity/session-options.module.ts",
		"student-activity-session-options-module"
	],
	"../student-activity/students-list.module": [
		"./src/app/student-activity/students-list.module.ts"
	],
	"../student-progress/student-progress.module": [
		"./src/app/student-progress/student-progress.module.ts"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;